import ProjectIcon from '@assets/img/navigation_icons/project-icon.png';
import DocumentIcon from '@assets/img/navigation_icons/document-icon.png';
import SearchIcon from '@assets/img/navigation_icons/search-icon.png';
import TamerIcon from '@assets/img/navigation_icons/tamer-icon.png';
import ListIcon from '@assets/img/navigation_icons/list-icon.png';
import SettingIcon from '@assets/img/navigation_icons/settings-icon.png';
import RequestIcon from '@assets/img/navigation_icons/requests-icon.png';
import ActivityIcon from '@assets/img/navigation_icons/activity-icon.png';
import AnalyticsIcon from '@assets/img/navigation_icons/analytics-icon.png';
import FAQIcon from '@assets/img/navigation_icons/faq-icon.png';
import HomeIcon from '@assets/img/navigation_icons/home-icon.png';

const getNavigationIcon = {


    getIcon(type) {
        switch(type) {
            case 'home':
                return HomeIcon;
            case 'project':
                return ProjectIcon;
            case 'document':
                return DocumentIcon;
            case 'search':
                return SearchIcon;
            case 'tamer':
                return TamerIcon;
            case 'list':
                return ListIcon;
            case 'setting':
                return SettingIcon;
            case 'request':
                return RequestIcon;
            case 'projects-request':
                return RequestIcon;
            case 'documents-request':
                return RequestIcon;
            case 'activity':
                return ActivityIcon;
            case 'analytics':
                return AnalyticsIcon;
            case 'faq':
                return FAQIcon;
            default:
                return SettingIcon;    
        }
    }
}
export default getNavigationIcon;